import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./EsameDetailPage.css";

const ImpedenzometriaPage: React.FC = () => {
  return (
    <div className="esame-detail-page">
      <div className="esame-detail-container">
        <Link to="/esami" className="esame-detail-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Torna agli esami
        </Link>

        <div className="esame-detail-content">
          <div className="esame-detail-text">
            <h1 className="esame-detail-title">
              Impedenzometria
            </h1>

            <div className="esame-detail-description">
              <h2>Cos'è</h2>
              <p>
                Permette di valutare il funzionamento di tutta la catena di trasmissione del suono 
                quindi: il grado di elasticità del timpano ma anche la capacità di movimento degli 
                ossicini dell'orecchio medio e la funzionalità della tuba di Eustachio.
              </p>

              <h2>Come si svolge</h2>
              <p>
                L'esame si effettua utilizzando una sonda che emette un suono di intensità variabile 
                direttamente all'interno dell'orecchio del paziente e i risultati riportati sul 
                timpanogramma indicano la pressione interna dell'orecchio medio.
              </p>

              <h2>A cosa serve</h2>
              <p>
                L'impedenzometria è utile per:
              </p>
              <ul>
                <li>Valutare il funzionamento del timpano e dell'orecchio medio</li>
                <li>Diagnosticare patologie come otiti medie effusive</li>
                <li>Identificare problemi di funzionalità della tuba di Eustachio</li>
                <li>Controllare il movimento degli ossicini dell'orecchio</li>
                <li>Monitorare l'efficacia delle terapie per patologie dell'orecchio medio</li>
              </ul>
            </div>
          </div>

          <div className="esame-detail-image-container">
            <img
              src={require("../assets/carousel/PHOTO-2025-10-16-20-09-03 3.jpg")}
              alt="Impedenzometria"
              className="esame-detail-image"
            />
          </div>
        </div>

        <div className="esame-detail-cta">
          <h3>Vuoi prenotare questo esame?</h3>
          <p>
            Contattaci per maggiori informazioni o per fissare un appuntamento
          </p>
          <Link to="/#prenota" className="esame-detail-cta-btn">
            Prenota ora
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ImpedenzometriaPage;
